import React from "react";
import { Box,  Dialog,  DialogContent,  DialogTitle} from "@mui/material";
import MyLabel from "../../../components/myLabel";
import MyButton from "../../../components/myButton";

const MessageDialog =  ({frase, open, handleClose, handlerSalvar }) =>{

    return (
        <Dialog open={open} onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                <MyLabel component='p' text={" "} />
            </DialogTitle>
            <DialogContent>
                <Box sx={{ margin: '30px' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', width: '100%', margin: '10px' }}>
                        <MyLabel component='p' text={frase} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', width: '100%', margin: '10px' }}>
                        <MyButton
                            onClick={handleClose}
                            text='NÃO'
                            variant="contained"
                            size="small"
                        />
                        <MyButton
                            onClick={handlerSalvar}
                            text='SIM'
                            variant="contained"
                            size="small"
                            color='warning'
                        />
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    )
}
export default MessageDialog